/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const KONFIGURIERBARE_LISTENANSICHT_SPALTE_TYP = {
    SEMINARE_MATCHCODE: "SEMINARE_MATCHCODE",
    SEMINARE_STATUS: "SEMINARE_STATUS",
    SEMINARE_TEILNAHMEN: "SEMINARE_TEILNAHMEN",
    SEMINARE_BEGINN: "SEMINARE_BEGINN",
    SEMINARE_ENDE: "SEMINARE_ENDE",
    SEMINARE_TEILNAHMENMANUELLGENEHMIGEN: "SEMINARE_TEILNAHMENMANUELLGENEHMIGEN",
    SEMINARE_TITEL: "SEMINARE_TITEL",
    SEMINARE_SEMINARNUMMER: "SEMINARE_SEMINARNUMMER",
    SEMINARE_MAXIMALETEILNAHMEZAHL: "SEMINARE_MAXIMALETEILNAHMEZAHL",
    SEMINARE_MINIMALETEILNAHMEZAHL: "SEMINARE_MINIMALETEILNAHMEZAHL",
    SEMINARE_GEBLOCKTETEILNAHMEZAHL: "SEMINARE_GEBLOCKTETEILNAHMEZAHL",
    SEMINARE_AKTUELLETEILNAHMEZAHL: "SEMINARE_AKTUELLETEILNAHMEZAHL",
    SEMINARE_BUCHUNGMOEGLICHAB: "SEMINARE_BUCHUNGMOEGLICHAB",
    SEMINARE_BUCHUNGMOEGLICHBIS: "SEMINARE_BUCHUNGMOEGLICHBIS",
    SEMINARE_NURBUCHBARBISBEGINN: "SEMINARE_NURBUCHBARBISBEGINN",
    SEMINARE_KATEGORIEN: "SEMINARE_KATEGORIEN",
    SEMINARE_SACHKONTO: "SEMINARE_SACHKONTO",
    SEMINARE_DOZIERENDEBENACHRICHTIGEN: "SEMINARE_DOZIERENDEBENACHRICHTIGEN",
    SEMINARE_VERHALTENBEIDOPPELTERTEILNAHME: "SEMINARE_VERHALTENBEIDOPPELTERTEILNAHME",
    SEMINARE_PRUEFUNGVONDOPPELTENTEILNAHMEN: "SEMINARE_PRUEFUNGVONDOPPELTENTEILNAHMEN",
    SEMINARE_BENACHRICHTIGEBEIBUCHUNG: "SEMINARE_BENACHRICHTIGEBEIBUCHUNG",
    SEMINARE_BUCHUNGAUFWARTELISTE: "SEMINARE_BUCHUNGAUFWARTELISTE",
    SEMINARE_WARTELISTEAUTOMATISCHNACHRUECKEN: "SEMINARE_WARTELISTEAUTOMATISCHNACHRUECKEN",
    SEMINARE_RECHNUNGENMANUELLFREIGEBEN: "SEMINARE_RECHNUNGENMANUELLFREIGEBEN",
    SEMINARE_NURINSEMINARREIHEBUCHBAR: "SEMINARE_NURINSEMINARREIHEBUCHBAR",
    SEMINARE_LINKZURONLINEBUCHUNG: "SEMINARE_LINKZURONLINEBUCHUNG",
    SEMINARE_KURZERLINKZURONLINEBUCHUNG: "SEMINARE_KURZERLINKZURONLINEBUCHUNG",
    SEMINARE_TEILNAHMEERINNERUNGXTAGEVORBEGINN: "SEMINARE_TEILNAHMEERINNERUNGXTAGEVORBEGINN",
    SEMINARE_KOMMENDEAUFSTEIGENDVERGANGENEABSTEIGEND: "SEMINARE_KOMMENDEAUFSTEIGENDVERGANGENEABSTEIGEND",
    SEMINARE_ORT: "SEMINARE_ORT",
    SEMINARE_MITARBEITER: "SEMINARE_MITARBEITER",

    TEILNAHMEN_MATCHCODE: "TEILNAHMEN_MATCHCODE",
    TEILNAHMEN_SEMINARMATCHCODE: "TEILNAHMEN_SEMINARMATCHCODE",
    TEILNAHMEN_SEMINAREMATCHCODE: "TEILNAHMEN_SEMINAREMATCHCODE",
    TEILNAHMEN_STATUS: "TEILNAHMEN_STATUS",
    TEILNAHMEN_BEGINN: "TEILNAHMEN_BEGINN",
    TEILNAHMEN_ENDE: "TEILNAHMEN_ENDE",
    TEILNAHMEN_BESTELLNUMMER: "TEILNAHMEN_BESTELLNUMMER",
    TEILNAHMEN_PREIS: "TEILNAHMEN_PREIS",
    TEILNAHMEN_BUCHUNGSDATUM: "TEILNAHMEN_BUCHUNGSDATUM",
    TEILNAHMEN_BEMERKUNGEN: "TEILNAHMEN_BEMERKUNGEN",
    TEILNAHMEN_HERKUNFT: "TEILNAHMEN_HERKUNFT",
    TEILNAHMEN_ISTSTORNIERT: "TEILNAHMEN_ISTSTORNIERT",
    TEILNAHMEN_ISTABGESAGT: "TEILNAHMEN_ISTABGESAGT",
    TEILNAHMEN_TEILNAHMEADRESSEMATCHCODE: "TEILNAHMEN_TEILNAHMEADRESSEMATCHCODE",
    TEILNAHMEN_RECHNUNGSADRESSEMATCHCODE: "TEILNAHMEN_RECHNUNGSADRESSEMATCHCODE",
    TEILNAHMEN_ERHAELTZERTIFIKATE: "TEILNAHMEN_ERHAELTZERTIFIKATE",
    TEILNAHMEN_TEILNAHMEADRESSEEMAIL: "TEILNAHMEN_TEILNAHMEADRESSEEMAIL",
    TEILNAHMEN_RECHNUNGSADRESSEEMAIL: "TEILNAHMEN_RECHNUNGSADRESSEEMAIL",
    TEILNAHMEN_ANWESEND: "TEILNAHMEN_ANWESEND",
    TEILNAHMEN_TERMINE: "TEILNAHMEN_TERMINE",
    TEILNAHMEN_ARTIKEL: "TEILNAHMEN_ARTIKEL",
    TEILNAHMEN_ZUSATZFELD: "TEILNAHMEN_ZUSATZFELD",

    ZAHLUNGEN_BEZEICHNUNG: "ZAHLUNGEN_BEZEICHNUNG",
    ZAHLUNGEN_BETRAG: "ZAHLUNGEN_BETRAG",
    ZAHLUNGEN_ZAHLUNGSTYP: "ZAHLUNGEN_ZAHLUNGSTYP",
    ZAHLUNGEN_ZAHLUNGSSTATUS: "ZAHLUNGEN_ZAHLUNGSSTATUS",
    ZAHLUNGEN_DATUM: "ZAHLUNGEN_DATUM",
    ZAHLUNGEN_BELEGNUMMER: "ZAHLUNGEN_BELEGNUMMER",

    ADRESSEN_MATCHCODE: "ADRESSEN_MATCHCODE",
    ADRESSEN_EMAIL: "ADRESSEN_EMAIL",
    ADRESSEN_ADRESSART: "ADRESSEN_ADRESSART",
    ADRESSEN_ANREDE: "ADRESSEN_ANREDE",
    ADRESSEN_BRIEFANREDE: "ADRESSEN_BRIEFANREDE",
    ADRESSEN_FAX: "ADRESSEN_FAX",
    ADRESSEN_GEBURTSDATUM: "ADRESSEN_GEBURTSDATUM",
    ADRESSEN_GESCHLECHT: "ADRESSEN_GESCHLECHT",
    ADRESSEN_HATRECHNUNGSADRESSE: "ADRESSEN_HATRECHNUNGSADRESSE",
    ADRESSEN_HOMEPAGE: "ADRESSEN_HOMEPAGE",
    ADRESSEN_ISTHAUPTADRESSE: "ADRESSEN_ISTHAUPTADRESSE",
    ADRESSEN_KATEGORIEN: "ADRESSEN_KATEGORIEN",
    ADRESSEN_LAND: "ADRESSEN_LAND",
    ADRESSEN_LANDBEZEICHNUNG: "ADRESSEN_LANDBEZEICHNUNG",
    ADRESSEN_MOBIL: "ADRESSEN_MOBIL",
    ADRESSEN_NACHNAME: "ADRESSEN_NACHNAME",
    ADRESSEN_NAME1: "ADRESSEN_NAME1",
    ADRESSEN_NAME2: "ADRESSEN_NAME2",
    ADRESSEN_NAME3: "ADRESSEN_NAME3",
    ADRESSEN_ORT: "ADRESSEN_ORT",
    ADRESSEN_POSTLEITZAHL: "ADRESSEN_POSTLEITZAHL",
    ADRESSEN_REGION: "ADRESSEN_REGION",
    ADRESSEN_STRASSE: "ADRESSEN_STRASSE",
    ADRESSEN_TELEFON: "ADRESSEN_TELEFON",
    ADRESSEN_TITEL: "ADRESSEN_TITEL",
    ADRESSEN_VORNAME: "ADRESSEN_VORNAME",
    ADRESSEN_RECHNUNGSADRESSEADRESSART: "ADRESSEN_RECHNUNGSADRESSEADRESSART",
    ADRESSEN_RECHNUNGSADRESSEANREDE: "ADRESSEN_RECHNUNGSADRESSEANREDE",
    ADRESSEN_RECHNUNGSADRESSEBRIEFANREDE: "ADRESSEN_RECHNUNGSADRESSEBRIEFANREDE",
    ADRESSEN_RECHNUNGSADRESSEEMAIL: "ADRESSEN_RECHNUNGSADRESSEEMAIL",
    ADRESSEN_RECHNUNGSADRESSEFAX: "ADRESSEN_RECHNUNGSADRESSEFAX",
    ADRESSEN_RECHNUNGSADRESSEGEBURTSDATUM: "ADRESSEN_RECHNUNGSADRESSEGEBURTSDATUM",
    ADRESSEN_RECHNUNGSADRESSEGESCHLECHT: "ADRESSEN_RECHNUNGSADRESSEGESCHLECHT",
    ADRESSEN_RECHNUNGSADRESSEHOMEPAGE: "ADRESSEN_RECHNUNGSADRESSEHOMEPAGE",
    ADRESSEN_RECHNUNGSADRESSELAND: "ADRESSEN_RECHNUNGSADRESSELAND",
    ADRESSEN_RECHNUNGSADRESSELANDBEZEICHNUNG: "ADRESSEN_RECHNUNGSADRESSELANDBEZEICHNUNG",
    ADRESSEN_RECHNUNGSADRESSEMOBIL: "ADRESSEN_RECHNUNGSADRESSEMOBIL",
    ADRESSEN_RECHNUNGSADRESSENACHNAME: "ADRESSEN_RECHNUNGSADRESSENACHNAME",
    ADRESSEN_RECHNUNGSADRESSENAME1: "ADRESSEN_RECHNUNGSADRESSENAME1",
    ADRESSEN_RECHNUNGSADRESSENAME2: "ADRESSEN_RECHNUNGSADRESSENAME2",
    ADRESSEN_RECHNUNGSADRESSENAME3: "ADRESSEN_RECHNUNGSADRESSENAME3",
    ADRESSEN_RECHNUNGSADRESSEORT: "ADRESSEN_RECHNUNGSADRESSEORT",
    ADRESSEN_RECHNUNGSADRESSEPOSTLEITZAHL: "ADRESSEN_RECHNUNGSADRESSEPOSTLEITZAHL",
    ADRESSEN_RECHNUNGSADRESSEREGION: "ADRESSEN_RECHNUNGSADRESSEREGION",
    ADRESSEN_RECHNUNGSADRESSESTRASSE: "ADRESSEN_RECHNUNGSADRESSESTRASSE",
    ADRESSEN_RECHNUNGSADRESSETELEFON: "ADRESSEN_RECHNUNGSADRESSETELEFON",
    ADRESSEN_RECHNUNGSADRESSETITEL: "ADRESSEN_RECHNUNGSADRESSETITEL",
    ADRESSEN_RECHNUNGSADRESSEVORNAME: "ADRESSEN_RECHNUNGSADRESSEVORNAME",
    ADRESSEN_MANDANTENKONTOEMAIL: "ADRESSEN_MANDANTEN_KONTOEMAIL",
    ADRESSEN_MANDANTENKONTOMANDANTEINGELADENUTC: "ADRESSEN_MANDANTEN_KONTOMANDANTEINGELADENUTC",
    ADRESSEN_ZUSATZFELD: "ADRESSEN_ZUSATZFELD",

    DOZIERENDE_MATCHCODE: "DOZIERENDE_MATCHCODE",
    DOZIERENDE_TITEL: "DOZIERENDE_TITEL",
    DOZIERENDE_BERUF: "DOZIERENDE_BERUF",
    DOZIERENDE_VORNAME: "DOZIERENDE_VORNAME",
    DOZIERENDE_NACHNAME: "DOZIERENDE_NACHNAME",
    DOZIERENDE_GEBURTSDATUM: "DOZIERENDE_GEBURTSDATUM",
    DOZIERENDE_STRASSE: "DOZIERENDE_STRASSE",
    DOZIERENDE_POSTLEITZAHL: "DOZIERENDE_POSTLEITZAHL",
    DOZIERENDE_ORT: "DOZIERENDE_ORT",
    DOZIERENDE_REGION: "DOZIERENDE_REGION",
    DOZIERENDE_LAND: "DOZIERENDE_LAND",
    DOZIERENDE_EMAIL: "DOZIERENDE_EMAIL",
    DOZIERENDE_TELEFON: "DOZIERENDE_TELEFON",
    DOZIERENDE_FAX: "DOZIERENDE_FAX",
    DOZIERENDE_MOBIL: "DOZIERENDE_MOBIL",
    DOZIERENDE_HOMEPAGE: "DOZIERENDE_HOMEPAGE",
    DOZIERENDE_BEMERKUNGEN: "DOZIERENDE_BEMERKUNGEN",
    DOZIERENDE_QUALIFIKATIONEN: "DOZIERENDE_QUALIFIKATIONEN",
    DOZIERENDE_VITA: "DOZIERENDE_VITA",
    DOZIERENDE_MANDANTEN_KONTOEMAIL: "DOZIERENDE_MANDANTEN_KONTOEMAIL",
    DOZIERENDE_MANDANTEN_KONTOMANDANTEINGELADENUTC: "DOZIERENDE_MANDANTEN_KONTOMANDANTEINGELADENUTC",
    DOZIERENDE_ZUSATZFELD: "DOZIERENDE_ZUSATZFELD",

    BESTELLTEARTIKEL_BEZEICHNUNG: "BESTELLTEARTIKEL_BEZEICHNUNG",
    BESTELLTEARTIKEL_RECHNUNGSADRESSEMATCHCODE: "BESTELLTEARTIKEL_RECHNUNGSADRESSEMATCHCODE",
    BESTELLTEARTIKEL_SEMINARREIHEMATCHCODE: "BESTELLTEARTIKEL_SEMINARREIHEMATCHCODE",
    BESTELLTEARTIKEL_SEMINARMATCHCODE: "BESTELLTEARTIKEL_SEMINARMATCHCODE",
    BESTELLTEARTIKEL_STATUS: "BESTELLTEARTIKEL_STATUS",
    BESTELLTEARTIKEL_BESTELLNUMMER: "BESTELLTEARTIKEL_BESTELLNUMMER",
    BESTELLTEARTIKEL_MENGE: "BESTELLTEARTIKEL_MENGE",
    BESTELLTEARTIKEL_PREIS: "BESTELLTEARTIKEL_PREIS",
    BESTELLTEARTIKEL_SUMME: "BESTELLTEARTIKEL_SUMME",
    BESTELLTEARTIKEL_KAUFDATUM: "BESTELLTEARTIKEL_KAUFDATUM",
    BESTELLTEARTIKEL_RECHNUNGSADRESSEEMAIL: "BESTELLTEARTIKEL_RECHNUNGSADRESSEEMAIL",
} as const;

type KonfigurierbareListenansichtSpalteTyp = typeof KONFIGURIERBARE_LISTENANSICHT_SPALTE_TYP[keyof typeof KONFIGURIERBARE_LISTENANSICHT_SPALTE_TYP];

export default KonfigurierbareListenansichtSpalteTyp;